import { gql } from 'apollo-angular';

export const SAVE_NON_BPS_SECTION_A = gql`
  mutation SaveNonBpsDetails($input: NonBpsSectionADtoInput!) {
    saveNonBpsDetails(input: $input) {
      code
      data {
        active
        attachableDiscriminator
        bucketName
        businessScopeDescription
        id
        importationLicenseExpiration
        otherAttachmentName
        registrationStatus
        registrationType
        tin
        traImportationLicense
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SAVE_NON_BPS_COMPANY_SECTION_B = gql`
 mutation SaveImportationLicenseDetails {
    saveImportationLicenseDetails {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            attachableDiscriminator
            bucketName
            businessScopeDescription
            createdAt
            createdBy
            deleted
            deletedAt
            deletedBy
            id
            importationLicenseExpiration
            otherAttachmentName
            registrationNumber
            registrationStatus
            registrationType
            tin
            traImportationLicense
            uuid
            importationLicences {
                active
                ewuraLicenseNumber
                id
                incorpRegistrationCertificateIssuanceDate
                incorpRegistrationCertificateNumber
                licenseExpireDate
                licenseStartDate
                licenseYear
                lisenceIssuedDate
                nameOfCompany
                omcNumber
                updatedAt
                updatedBy
                uuid
            }
        }
    }
}
`;

export const SUBMIT_NON_BPS_REGISTRATION = gql`
  mutation SubmitNonBpsRegistration {
    submitNonBpsRegistration {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        businessScopeDescription
        id
        importationLicenseExpiration
        otherAttachmentName
        registrationStatus
        registrationType
        tin
        traImportationLicense
        uuid
      }
    }
  }
`;

export const GET_NON_BPS_REGISTRATION_STATUS = gql`
  query GetMyNonBpsRegistrationProgress {
    getMyNonBpsRegistrationProgress {
      code
      extras
      fieldsErrors
      message
      status
      data {
        allSectionsComplete
        completionPercentage
        operatorUuid
        sectionAComplete
        sectionACompletedAt
        sectionBComplete
        sectionBCompletedAt
        sectionCComplete
        sectionCCompletedAt
      }
    }
  }
`;

export const GET_NON_BPS_ATTACHMENT_TYPES = gql`
  query GetAttachmentTypesByRegistrationType($registrationType: RegistrationType!) {
    getAttachmentTypesByRegistrationType(registrationType: $registrationType) {
      uuid
      isRequired
      registrationType
      forInternational
      forLocal
      attachmentType {
        uuid
        name
        fileType
        fileSize
      }
    }
  }
`;

export const VERIFY_NON_BPS_TIN = gql`
  query VerifyTaxId($input: TaxIdVerificationDtoInput) {
    verifyTaxId(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        taxCenter
        taxRegion
        taxpayerName
        tin
        verificationStatus
      }
    }
  }
`;

export const UPLOAD_NON_BPS_ATTACHMENT = gql`
  mutation UploadAttachment($input: AttachmentUploadDtoInput!) {
    uploadAttachment(attachmentDto: $input) {
      code
      message
      status
      data {
        uuid
        minioObjectName
        attachmentType {
          uuid
          name
          fileType
        }
      }
      fieldsErrors
      extras
    }
  }
`;

export const VIEW_NON_BPS_ATTACHMENT = gql`
  query ViewAttachmentByUuid($attachmentUuid: String!) {
    viewAttachmentByUuid(attachmentUuid: $attachmentUuid) {
      code
      data
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const DELETE_NON_BPS_ATTACHMENT = gql`
  mutation DeleteAttachment($attachmentUuid: String!) {
    deleteAttachment(attachmentUuid: $attachmentUuid) {
      code
      data
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_PRODUCT_CATEGORIES = gql`
  query GetProductCategories($fetchAll: Boolean) {
    getProductCategories(fetchAll: $fetchAll) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        code
        deleted
        name
        uuid
        deletedAt
      }
    }
  }
`;
